import { get } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { useActions } from '../../hooks/useActions'
import { pathToPerson } from '../../utils/helpers'
import Chooser from '../../widgets/Chooser'

const RelatedToPartner = ({ id }) => {
  const { setPersonPropertiesIsPresent, setPartnerConsanguinity, removePartnerConsanguinity } =
    useActions()
  const relatedToPartner =
    useSelector((state) => {
      const properties = get(state, [...pathToPerson(id), 'properties']) || []

      return properties.find(({ type }) => type === 'isRelatedToPartner')
    }) || {}
  const chooserValue =
    relatedToPartner.isPresent === 'N' && relatedToPartner.value === 'Not applicable'
      ? 'NA'
      : relatedToPartner.isPresent

  return (
    <Chooser
      label="Are you related to your partner in any way?"
      options={[
        ['Y', 'Yes'],
        ['N', 'No'],
        ['U', 'Unknown'],
        ['NA', 'Not applicable'],
      ]}
      selectedValue={chooserValue}
      onChange={(value) => {
        if (value === chooserValue) return

        setPersonPropertiesIsPresent({ id, type: 'isRelatedToPartner', value })
        if (value === 'Y' || value === 'N') {
          setPartnerConsanguinity({ value })
        } else {
          removePartnerConsanguinity()
        }
      }}
    />
  )
}

export default RelatedToPartner
